import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { getPageName } from '../../../../../utils/pageName';
import styles from '../restricted_modal.module.scss';
import { RestrictedModalLayout } from '../RestrictedModalLayout';
import { ModalRestrictedContainer } from '../../modal-container/ModalRestrictedContainer';
import { buildUrlWithParameters } from '../../../../../utils/url-utils/urlUtils';
import { BrandHyperlink } from '../../../../button/brand/BrandHyperlink';
import { useLoginModal } from '../../../../../login/useLoginModal';

type Props = {
  closeModal: () => void;
  source: string;
  title: React.ReactNode;
  subtitle: React.ReactNode;
  icon: React.ReactNode;
  isOpen: boolean;
};

export const PublicRestrictedModal: FC<Props> = ({
  closeModal,
  source,
  title,
  icon,
  subtitle,
  isOpen,
}) => {
  const sourcePage: string = getPageName();

  const { openLoginModal } = useLoginModal();

  const openLoginCta = () => {
    closeModal();
    openLoginModal({ source });
  };

  return (
    <ModalRestrictedContainer onRequestClose={closeModal} isOpen={isOpen}>
      <RestrictedModalLayout closeModal={closeModal} source={source}>
        {icon}
        <div className={styles.title}>{title}</div>
        {!!subtitle && <div className={styles.subtitle}>{subtitle}</div>}
        <div className={styles.startButton}>
          <BrandHyperlink
            large
            href={buildUrlWithParameters('/inscription', {
              source,
              sourcePage,
            })}
            iconLeft="arrow_forward"
          >
            <FormattedMessage id="modal-restricted/public/PublicRestrictedModal.tsx/1" />
          </BrandHyperlink>
        </div>
        <div className={styles.bottom}>
          <FormattedMessage id="modal-restricted/public/PublicRestrictedModal.tsx/2" />
          <button
            type="button"
            className={styles.bottomLink}
            onClick={openLoginCta}
          >
            <FormattedMessage id="modal-restricted/public/PublicRestrictedModal.tsx/3" />
          </button>
        </div>
      </RestrictedModalLayout>
    </ModalRestrictedContainer>
  );
};
